<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<div class="figcenter2" id="frontis">
<img alt="" class="w" id="id-7636735342487866151" src="Images/img0001.jpg"/>
<div class="caption"><p class="center">Persis was at that moment knitting her brows over some papers
at a table in Annis’s little attic room.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?fc1a6e82